
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FaturamentoData, { FaturamentoDataRequired } from "../FaturamentoData";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table3.vue"
import { SistemaMixin, ValidacaoMixin, InstallmentsMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { store } from "../../storeServicos";
import moment from "moment";

export default {
  name: "app-nfse-form-faturamentoTab",
  components: {
    VueSelect,
    Money,
    TableApp,
    TrashCanIcon,
  },

  directives: {
    mask,
  },
  data() {
    return {
      store,
      form: {},
      vencimento: [],
      configMask: settingMoney,
      categorias: [],
      contas: [],
      vencimentoSelected: null,
      indexVencimento: null,
      pagamento: [],
      blockNFSe: false,
      formas_pagamento: [],
      formasPagamentoArray: [],
      pagamentosEditados: [],
      plano_contas: [],
      selectedPagamento: null,
      keyToReRender: 0,
      pagamentosRealizados: [],
      fieldsPagamentosRealizados: [
        {
          label: "",
          field: "forma_pagamento",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "",
          field: "actions",
          slot: true,
          width: "10%",
          sortable: false
        },
      ],
      fields: [
        {
          label: "",
          field: "id",
          slot: true,
          width: "10%",
          sortable: false
        },
        {
          label: "Valor R$",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "Vencimento",
          field: "vencimento",
          slot: true,
          sortable: false,
          width: "45%"
        },
      ],
      subtotal: 0,
      valorPagoARealizar: 0,
      valorPago: 0,
      formaPagamento: null,
      planoConta: null,
      openChangeVencimentoModal: false,
      informacoesAdicionais: '',
      pagamentoEditado: 0,
      valorError: false,
      valorFilled: false,
      pagamentoError: false,
      pagamentoFilled: false,
      planoContasError: false,
      planoContasFilled: false,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, InstallmentsMixin],
  validations: {
    form: FaturamentoDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.form = new FaturamentoData({});
      this.vencimentoSelected = this.thisDate();
      this.formas_pagamento = await this.getFormasPagamentos();
      this.formasPagamentoArray = this.formas_pagamento;
      this.plano_contas = await this.getPlanoContas(2);
      this.planoConta = this.plano_contas.find(plano => plano.descricao === "Venda de Serviços");
      this.form.informacoes_complementares = this.store.informacoesComplementares ?? null;
    },
    resetPayment() {
      this.pagamentosRealizados = [];
      this.form.pagamentos = [];
      this.valorPago = 0;
      this.valorPagoARealizar = this.store.formServicos.reduce((acc, servico) => acc + servico.total, 0);
      this.subtotal = this.valorPagoARealizar;
      this.form.informacoes_complementares = "";
    },
    removePagamento(pagamentoDeleted, indexToRemove) {
      this.store.formPagamento.pagamentos = this.store.formPagamento.pagamentos.filter((pagamento, index) => index !== indexToRemove);
      this.pagamentosRealizados = this.pagamentosRealizados.filter((pagamento, index) => index !== indexToRemove);
      this.subtotal = this.subtotal + pagamentoDeleted.valor;
      this.valorPago = this.valorPago - pagamentoDeleted.valor
    },
    changePagamento(pagamentoIndex) {
      this.selectedPagamento = pagamentoIndex
    },
    closeModalPagamento() {
      this.openChangePagamentoModal = false;
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarPagamento() {
      this.pagamento[this.selectedPagamento].valor = this.pagamentoEditado;
      const indexEditPagamento = this.pagamentosEditados.findIndex(pagamento => pagamento?.index === this.selectedPagamento)
      if (indexEditPagamento === -1) {
        this.pagamentosEditados.push({
          index: this.selectedPagamento,
          value: this.pagamentoEditado
        })
      } else {
        this.pagamentosEditados.splice(indexEditPagamento, 1, {
          index: this.selectedPagamento,
          value: this.pagamentoEditado
        })
      };

      const pagamentosEditadosTotal = this.pagamentosEditados.reduce((acc, pagamento) => {
        if (pagamento?.value) return acc + pagamento.value
        else return acc
      }, 0)

      const editPagamentoCount = this.pagamentosEditados.length

      const pagamentoRestante = this.valorPagoARealizar - pagamentosEditadosTotal;
      const valorParcelasRestantes = Math.round(pagamentoRestante / (this.pagamento.length - editPagamentoCount) * 100) / 100;

      this.pagamento = this.pagamento.map((item, index) => {
        const hasInPagamentosEditado = this.pagamentosEditados.find(pagamento => pagamento.index === index)
        return {
          ...item,
          valor: hasInPagamentosEditado ?
            hasInPagamentosEditado.value
            :
            index !== this.selectedPagamento ?
              valorParcelasRestantes
              :
              this.pagamentoEditado
        }
      })

      this.$bvModal.hide('modal-pagamento')
    },
    validateFaturamentoState() { },
    onSearchConta(search, loading) {
      if (search.length) {
        loading(true);
        this.searchContas(loading, search, this);
      }
    },
    selectVencimento(index) {
      this.indexVencimento = index
    },
    salvarVencimento() {
      this.pagamento[this.indexVencimento].vencimento = this.vencimentoSelected;
      this.$bvModal.hide('modal-calendar')
    },
    closeModalCalendario() {
      this.openChangeVencimentoModal = false;
    },
    clearInputs() {
      this.formaPagamento = null
      this.informacoesAdicionais = ''
      this.planoConta = this.plano_contas.find(plano => plano.descricao === "Venda de Serviços")
      this.valorPagoARealizar = 0
      this.form.vencimento = this.thisDate()
      this.pagamento = []
      this.pagamentosEditados = [];
    },
    addPagamento() {
      this.form.pagamentos = [...this.form.pagamentos, {
        forma_pagamento: this.formaPagamento,
        informacoes_adicionais: this.informacoesAdicionais,
        plano_conta: this.planoConta,
        valor: this.valorPagoARealizar,
        vencimento: this.form.vencimento,
        range: this.pagamento.map(parcela => ({
          value: parcela.valor,
          date: moment(parcela.vencimento).format('YYYY-MM-DD')
        }))
      }]
      this.pagamentosRealizados = this.form.pagamentos
      this.valorPago = this.form.pagamentos.reduce((acc, pagamento) => acc + pagamento.valor, 0)
      this.subtotal = this.store.formServicos.reduce((acc, servico) => acc + servico.total, 0) - this.valorPago
      this.clearInputs();
      this.keyToReRender++;
    },
    onSearchCategorias(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCategorias(loading, search, this);
      }
    },
    onSearchFormaPagamentos(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFormaPagamentos(search, loading, this);
      } else {
        this.formas_pagamento = this.formasPagamentoArray
      }
    },
    onInputValue(valor) {
      if (valor > this.subtotal) {
        this.$toast.warning('Valor maior que o total da Nota!');
        this.blockNFSe = true;
      } else this.blockNFSe = false;
      this.changePagamentoValue(valor, this);
    },
    changePagamentoValue: _.debounce((valor, vm) => {
      vm.valorPagoARealizar = valor;
      if (valor === 0) return;
      vm.pagamento = vm.calculateInstallments(vm.formaPagamento, vm.valorPagoARealizar).map(el => ({
        vencimento: el.date,
        valor: el.value
      }))
      vm.vencimentoSelected = vm.pagamento[0]?.vencimento;

      vm.valorError = false
      vm.valorFilled = true
    }, 1000),

    setFormaPagamento(forma_pagamento) {
      this.pagamento = this.calculateInstallments(forma_pagamento, this.valorPagoARealizar).map(el => ({
        vencimento: el.date,
        valor: el.value
      }))
      this.vencimentoSelected = this.pagamento[0]?.vencimento;
      this.formaPagamento = forma_pagamento
      this.pagamentoError = false
      this.pagamentoFilled = true
      this.pagamentosEditados = [];
    },
    searchFormaPagamentos: _.debounce(async (search, loading, vm) => {
      vm.formas_pagamento = vm.formasPagamentoArray.filter(item => item.descricao.includes(search));
      loading(false);
    }, 350),
    searchCategorias: _.debounce(async (search, loading, vm) => {
      vm.plano_contas = vm.plano_contas.filter(item => item.descricao.includes(search))
      loading(false);
    }, 350),
    searchContas: _.debounce(async (search, loading, vm) => {
      vm.form.conta = await vm.getContas(search);
      loading(false);
    }, 350),
  },

  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.getDataInit();
      const { parcelas: pagamentos, informacoes_complementares } = this.$route.params.nfseData;
      this.form.pagamentos = pagamentos;
      this.pagamentosRealizados = this.form.pagamentos;
      this.valorPago = this.pagamentosRealizados.reduce((acc, pagamento) => acc + pagamento.valor, 0)
      this.subtotal = this.store.formServicos.reduce((acc, servico) => acc + servico.total, 0) - this.valorPago;
      this.store.informacoesComplementares = informacoes_complementares;
    } else {
      this.getDataInit();
    }
  },
  watch: {
    'store.formPagamento.pagamentos'(newValue) {
      this.valorPago = newValue.reduce((acc, pagamento) => acc + pagamento.valor, 0)
    },
    'store.formPagamento'(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
      this.form = newValue;
      this.pagamentosRealizados = newValue.pagamentos;
    },
    'store.formServicos': {
      handler(servicos) {
        this.valorPago = this.pagamentosRealizados.reduce((acc, pagamento) => acc + (pagamento?.valor ?? 0), 0);
        this.valorPagoARealizar = servicos.reduce((acc, servico) => acc + servico.total, 0) - this.valorPago;
        this.subtotal = this.valorPagoARealizar;
      },
      deep: true,
    },
    'form.vencimento'(newVencimento, oldVencimento) {
      if (newVencimento !== oldVencimento) {
        if (!this.formaPagamento) return;
        this.pagamento = this.calculateInstallments(this.formaPagamento, this.valorPagoARealizar).map(el => ({
        vencimento: el.date,
        valor: el.value
      }))
      this.vencimentoSelected = this.pagamento[0]?.vencimento;
      }
    },
    form(newValue) {
      this.store.formPagamento = newValue;
    },
    planoConta(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
      this.planoContasFilled = true;
      this.store.formPagamento.plano_conta = newValue
    },
    'store.currentTab'(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 3 && oldValue < newValue) {
        this.$v.form.$touch();

        if (this.store.formPagamento.pagamentos.length === 0) {
          if (!this.valorPagoARealizar) {
            this.$toast.error('Necessário incluir o valor')
            this.valorError = true
          }
          if (!this.formaPagamento) {
            this.pagamentoError = true
            this.$toast.error("Necessário incluir forma de pagamento");
          }
          if (!this.planoConta) {
            this.$toast.error("Necessário incluir plano de contas");
            this.planoContasError = true
          }
          this.$toast.error("Necessário incluir pagamento");
          this.store.currentTab = oldValue
          return;
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isAllInputsNotFull() {
      return (this.valorPagoARealizar === 0 || !this.formaPagamento || !this.planoConta || this.blockNFSe)
    },
    valorPagamento() {
      if (this.pagamento.length === 0) return 0
      else return this.pagamento[0].valor
    },
    isTheCurrentTab() {
      return store.currentTab === 2
    }
  }
}

